export default __webpack_public_path__ + "static/about-us-3-desktop-fc5c835eb141198adddb8c1f7334f835.png";